document.addEventListener("DOMContentLoaded", () => {
  function openDropdownsOnMouseover() {
    if (window.innerWidth < 768) return;
    const detailsEl = document.querySelectorAll("details");
    detailsEl.forEach((el) => {
      el.addEventListener("mouseover", function () {
        this.setAttribute("open", true);
      });
      el.addEventListener("mouseleave", function () {
        this.removeAttribute("open");
      });
    });
  }

  openDropdownsOnMouseover();

  // GSAP
  gsap.registerPlugin(ScrollTrigger);

  gsap.utils.toArray("h2:not(.typography-effect)").forEach((h2) => {
    gsap.from(h2, {
      opacity: 0,
      filter: "blur(10px) hue-rotate(180deg)", // Added blue filter
      x: -100,
      duration: 1.5,
      ease: "power2.out",
      scrollTrigger: {
        trigger: h2,
        start: "top 90%", // Starts when the top of the element reaches 80% of the viewport
        toggleActions: "play none none none", // Runs animation once
      },
    });
  });

  gsap.utils.toArray(".image-with-text p").forEach((p) => {
    gsap.from(p, {
      opacity: 0,
      x: 100,
      duration: 1.5,
      ease: "power2.out",
      scrollTrigger: {
        trigger: p,
        start: "top 70%", // Starts when the top of the element reaches 90% of the viewport
        toggleActions: "play none none none", // Runs animation once
      },
    });
  });

  gsap.utils.toArray(".image-with-text .media").forEach((media) => {
    gsap.from(media, {
      opacity: 0,
      filter: "blur(5px)",
      y: 100,
      duration: 1.5,
      ease: "power2.out",
      scrollTrigger: {
        trigger: media,
        start: "top 80%", // Starts when the top of the element reaches 90% of the viewport
        toggleActions: "play none none none", // Runs animation once
      },
    });
  });

  gsap.utils.toArray(".glass-cards__card").forEach((card, index) => {
    gsap.from(card, {
      opacity: 0,
      rotationY: 180,
      duration: 1.5,
      ease: "power2.out",
      delay: index * 0.2, // Adds a delay on each card
      scrollTrigger: {
        trigger: card,
        start: "top 80%", // Starts when the top of the element reaches 80% of the viewport
        toggleActions: "play none none none", // Runs animation once
      },
    });
  });

  //typography effect
  // Every letter fades in and moves up
  gsap.utils.toArray(".typography-effect").forEach((element) => {
    const letters = element.textContent.split("");
    const newContent = letters
      .map(
        (letter) =>
          `<span style="display: inline-block; opacity: 0; transform: translateY(1em); font-weight: 500">${letter}</span>`
      )
      .join("");
    element.innerHTML = newContent;

    gsap.to(element.children, {
      opacity: 1,
      y: 0,
      duration: 2,
      stagger: 0.05,
      ease: "power4.inOut",
      scrollTrigger: {
        trigger: element,
        start: "top 90%", // Starts when the top of the element reaches 90% of the viewport
        toggleActions: "play none none none", // Runs animation once
      },
    });
  });

  document.querySelectorAll(".glass-cards__card").forEach((item) => {
    item.addEventListener("mousemove", (e) => {
      const rect = item.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      const rotateX = (y - centerY) / 10;
      const rotateY = (centerX - x) / 10;

      item.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    });

    item.addEventListener("mouseleave", () => {
      item.style.transition = "transform 0.5s ease"; // Add smooth transition
      item.style.transform = "perspective(1000px) rotateX(0deg) rotateY(0deg)";
    });

    item.addEventListener("mouseenter", () => {
      item.style.transition = "transform 0.5s ease"; // Add smooth transition
      item.style.transition = "none"; // Remove transition on mouse enter
    });
  });
});
